import { Injectable } from '@angular/core';
import { ProductShipment } from '@app/models';
import { ApiService } from '@app/services/api/api.service';
import { FlashService } from '@app/services/flash.service';
import * as ProductCountryAction from '@core/actions/product-country.actions';
import {
  BulkTransfer,
  BulkTransferFail,
  BulkTransferProforma,
  BulkTransferProformaFail,
  BulkTransferProformaSuccess,
  BulkTransferSuccess,
  BulkUpdate,
  BulkUpdateFail,
  BulkUpdateSuccess,
  BulkUpdateWeb,
  LoadByCountryDepartment,
  LoadByCountryDepartmentFail,
  LoadByCountryDepartmentSuccess,
  LoadByFollow,
  LoadByFollowFail,
  LoadByFollowSuccess,
  LoadByProductMirror,
  LoadByProductMirrorFail,
  LoadByProductMirrorSuccess,
  ProductShipmentActionTypes,
  VoidAction,
} from '@core/actions/product-shipment.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ProductShipmentEffects {
  // @Effect()
  // loadByProduct$: Observable<Action> = this.actions$.pipe(
  //   ofType<LoadByProduct>(ProductShipmentActionTypes.LoadByProduct),
  //   map(action => action.productId),
  //   switchMap(id =>
  //     this.api.getProductCountries(id).pipe(
  //       map(
  //         (countries: ProductCountry[]) => new LoadByProductSuccess(countries)
  //       ),
  //       catchError(error => of(new LoadByProductFail(error)))
  //     )
  //   )
  // );

  @Effect()
  loadByFollow$ = this.actions$.pipe(
    ofType<LoadByFollow>(ProductShipmentActionTypes.LoadByFollow),
    map((action) => [
      action.FollowId,
      action.CountryId,
      action.ProformaId,
      action.ProductId,
    ]),
    switchMap(([followId, countryId, proformaId, ProductId]) =>
      this.api
        .getProductShipmentsByFollow(followId, countryId, proformaId, ProductId)
        .pipe(
          map((shipments: ProductShipment[]) => {
            // new ProformaAction.Load(followId)
            return new LoadByFollowSuccess(shipments);
          }),
          catchError((error) => of(new LoadByFollowFail(error)))
        )
    )
  );

  //   @Effect()
  //   update$: Observable<Action> = this.actions$.pipe(
  //     ofType<Update>(ProductCountryActionTypes.Update),
  //     map(action => [action.id, action.data]),
  //     switchMap(([id, data]) => {
  //       return this.api.updateProductCountry(id, data).pipe(
  //         map(
  //           (productCountry: ProductCountry) => new UpdateSuccess(productCountry)
  //         ),
  //         catchError(error => of(new UpdateFail(error)))
  //       );
  //     })
  //   );

  //   @Effect()
  //   updateSuccess$: Observable<Action> = this.actions$.pipe(
  //     ofType<UpdateSuccess>(ProductCountryActionTypes.UpdateSuccess),
  //     map(action => new UpdateOne(action.productCountry))
  //   );

  @Effect()
  bulkUpdate$: Observable<Action> = this.actions$.pipe(
    ofType<BulkUpdate>(ProductShipmentActionTypes.BulkUpdate),
    map((action) => [action.data, action.dataLoad]),
    switchMap(([data, dataLoad]) => {
      // console.log('------', data);
      if (dataLoad) {
        return this.api.bulkUpdateProductShipments(data).pipe(
          map(
            (productShipments: ProductShipment[]) =>
              new BulkUpdateSuccess(productShipments, dataLoad)
            // this.fs.emit({ type: 'success', message: 'Unidades actualizadas' })
          ),
          catchError((error) => of(new BulkUpdateFail(error)))
        );
      } else {
        return this.api.bulkUpdateProductShipments(data).pipe(
          map(
            (productShipments: ProductShipment[]) =>
              new BulkUpdateSuccess(productShipments, data)
            // this.fs.emit({ type: 'success', message: 'Unidades actualizadas' })
          ),
          catchError((error) => of(new BulkUpdateFail(error)))
        );
      }
    })
  );

  @Effect()
  bulkUpdateWeb$: Observable<Action> = this.actions$.pipe(
    ofType<BulkUpdateWeb>(ProductShipmentActionTypes.BulkUpdateWeb),
    map((action) => [action.data, action.dataLoad]),
    switchMap(([data, dataLoad]) => {
      return this.api.bulkUpdateProductShipmentsNew(data).pipe(
        map(
          (productShipments: ProductShipment[]) =>
            new BulkUpdateSuccess(productShipments, data)
          // this.fs.emit({ type: 'success', message: 'Unidades actualizadas' })
        ),
        catchError((error) => of(new BulkUpdateFail(error)))
      );
    })
  );

  @Effect()
  bulkUpdateSuccess$ = this.actions$.pipe(
    ofType<BulkUpdateSuccess>(ProductShipmentActionTypes.BulkUpdateSuccess),
    map((action) => {
      // console.log(action.dataLoad);

      this.fs.emit({ type: 'success', message: 'Unidades actualizadas' });

      let CountryId;
      let ProductId;
      let ProformaId;

      if (
        action.dataLoad &&
        action.dataLoad.pcsIdsWithUnits &&
        action.dataLoad.pcsIdsWithUnits.length
      ) {
        CountryId = action.dataLoad.pcsIdsWithUnits[0].CountryId;
        ProductId = action.dataLoad.pcsIdsWithUnits[0].id;
      } else {
        CountryId = action.dataLoad.CountryId;
        ProductId = action.dataLoad.id;
      }

      const loadFilters = action.dataLoad;
      // if (action.dataLoad.ProductId) {
      //   return new ProductCountryAction.LoadByProductMirror(
      //     action.dataLoad.ProductId
      //   );
      // }

      if (!action.dataLoad.Load) {
        return new VoidAction();
      }
      // If showroom, add department name filter
      if (action.dataLoad.CountryDepartmentId) {
        return new LoadByCountryDepartment(
          action.dataLoad.FollowId,
          action.dataLoad.CountryDepartmentId,
          action.dataLoad.CountryId,
          action.dataLoad.businessUnit,
          action.dataLoad.DestinationCenterId
        );
      } else if (action.dataLoad.FollowId) {
        return new LoadByFollow(
          loadFilters.FollowId,
          CountryId,
          loadFilters.ProformaId,
          ProductId
        );
      } else {
        return new VoidAction();
      }
    })
  );

  @Effect()
  bulkTransfer$: Observable<Action> = this.actions$.pipe(
    ofType<BulkTransfer>(ProductShipmentActionTypes.BulkTransfer),
    map((action) => action.data),
    switchMap((data) => {
      return this.api.bulkTransferProductShipments(data).pipe(
        map(
          (productShipments: ProductShipment[]) =>
            new BulkTransferSuccess(productShipments)
        ),
        catchError((error) => of(new BulkTransferFail(error)))
      );
    })
  );

  @Effect()
  bulkTransferProforma$: Observable<Action> = this.actions$.pipe(
    ofType<BulkTransferProforma>(
      ProductShipmentActionTypes.BulkTransferProforma
    ),
    map((action) => action.data),
    switchMap((data) => {
      return this.api.bulkTransferProductProformas(data).pipe(
        map(
          (productShipments: ProductShipment[]) =>
            new BulkTransferProformaSuccess(productShipments)
        ),
        catchError((error) => of(new BulkTransferProformaFail(error)))
      );
    })
  );

  @Effect({ dispatch: false })
  BulkTransferProformaSuccess$ = this.actions$.pipe(
    ofType<BulkTransferProformaSuccess>(
      ProductShipmentActionTypes.BulkTransferProformaSuccess
    ),
    map((action) => {
      this.fs.emit({ type: 'success', message: 'Productos transferidos' });
    })
  );

  @Effect()
  loadByCountryDepartment$ = this.actions$.pipe(
    ofType<LoadByCountryDepartment>(
      ProductShipmentActionTypes.LoadByCountryDepartment
    ),
    map((action) => [
      action.FollowId,
      action.CountryDepartmentId,
      action.CountryId,
      action.businessUnit,
      action.typeHierarchy,
      action.DestinationCenterId,
    ]),
    switchMap(
      ([
        FollowId,
        CountryDepartmentId,
        CountryId,
        businessUnit,
        typeHierarchy,
        DestinationCenterId,
      ]) =>
        this.api
          .getProductShipmentsByShowroom(
            FollowId,
            CountryDepartmentId,
            CountryId,
            businessUnit,
            typeHierarchy,
            DestinationCenterId
          )
          .pipe(
            map(
              (productShipments: ProductShipment[]) =>
                new LoadByCountryDepartmentSuccess(productShipments)
            ),
            catchError((error) => of(new LoadByCountryDepartmentFail(error)))
          )
    )
  );

  @Effect()
  loadByProductMirror$: Observable<Action> = this.actions$.pipe(
    ofType<LoadByProductMirror>(ProductShipmentActionTypes.LoadByProductMirror),
    map((action) => action.ProductId),
    switchMap((ProductId) =>
      this.api.getProductShipmentMirrors(ProductId).pipe(
        map(
          (ProductShipmentMirror: ProductShipment[]) =>
            new LoadByProductMirrorSuccess(ProductShipmentMirror)
        ),
        catchError((error) => of(new LoadByProductMirrorFail(error)))
      )
    )
  );

  //   @Effect()
  //   bulkUpdateSuccess$: Observable<Action> = this.actions$.pipe(
  //     ofType<BulkUpdateSuccess>(ProductCountryActionTypes.BulkUpdateSuccess),
  //     map(action => new UpdateMany(action.productCountries))
  //   );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private fs: FlashService
  ) {}
}
